import { AlertDialogBody, AlertDialogFooter, Button, ButtonGroup, Center, Stack, Text, useDisclosure, useToast } from "@chakra-ui/react";
import { Alert, Dialog, Form, Icon, Lottie, Show } from "components";
import { API } from "config";
import { useState } from "react";
import { Authenticate } from "screens";

export default function Block({ data:employee, onSuccess = () => {}, ...props }){
    
    const toast = useToast()
    const [ blocked_reason, setBlockedReason ] = useState()
    const [ loading, setLoading ] = useState(false)
    const auth = useDisclosure()

    const handleSubmit = async () => {
        setLoading(true)

        try{
            await API.put(!employee?.blocked_at ? `/employees/${employee.id}/block` : `/employees/${employee.id}/unblock`, { blocked_reason })
            toast({ title: 'Operação realizada', status: 'info' })
            onSuccess()
            props.onClose()
        }catch(err){
            toast({ title: "Não foi possível bloquear o funcionário.", description: err?.response?.data?.message, status: 'warning' })
        }
        
        setLoading(false)
    }

    return(
    <>
    <Dialog {...props}>
        <AlertDialogBody>
            <Stack spacing={4}>

                <Lottie animation="block" style={{ height: 220 }} />

                <Center>
                    <Text fontSize="large" fontWeight="bold" children={!!employee?.blocked_at ? `Desbloquear funcionário` : `Bloquear funcionário`} />
                </Center>

                { !employee?.blocked_at && <Alert status="warning">Ao bloquear o funcionário, ele será desconectado de todas as sessões e será impedido de acessar o sistema novamente enquanto estiver bloqueado.</Alert>  }

                <Show visible={!employee?.blocked_at}>
                    <Form.Form onSubmit={auth.onOpen}>
                        
                        <Form.Textarea
                            label="Motivo do bloqueio:"
                            name="blocked_reason"
                            value={blocked_reason}
                            onChange={e => setBlockedReason(e.target.value)}
                            isDisabled={loading}
                            helper="O motivo do bloqueio aparacerá para os administradores."
                        />

                    </Form.Form>
                </Show>

            </Stack>
        </AlertDialogBody>
        <AlertDialogFooter>
            <ButtonGroup size="sm" isDisabled={loading}>
                <Button isLoading={loading} onClick={auth.onOpen} leftIcon={<Icon name="block" />} children={!!employee?.blocked_at ? `Desbloquear funcionário` : `Bloquear funcionário`} />
                <Button children="Cancelar" colorScheme="red" onClick={props.onClose} />
            </ButtonGroup>
        </AlertDialogFooter>
    </Dialog>

    <Authenticate {...auth} onSuccess={handleSubmit} />

    </>
    )
}